import { Fragment, PropsWithChildren } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import styles from './Tooltip.module.css';
import { HasClassName } from '~/types/HasClassName';
import classNames from 'classnames';

type Props = PropsWithChildren &
  HasClassName & {
    placement?: 'top' | 'bottom' | 'left' | 'right';
    as?: keyof JSX.IntrinsicElements;
    title: string;
  };

export function Tooltip({ title, children, placement, className, as: Component = 'button' }: Props) {
  const id = (Math.random() + 1).toString(36).substring(2);

  return (
    <Fragment>
      <Component
        className={classNames(styles.toggler, className)}
        data-tooltip-place={placement}
        data-tooltip-content={title}
        data-tooltip-id={id}
      >
        {children}
      </Component>

      <ReactTooltip id={id} className={styles.tooltip} />
    </Fragment>
  );
}
